import { GetKLogicDatasetBuilder } from '../elements/k-logic-editor/GetKLogicDatasetBuilder.js';
import { KLogic } from './KLogic.js';
import { getSpansNodeList } from './getSpansNodeList.js';

export async function GetWebAutomationData(
  automation,
  job,
  companyFiles,
  user_group,
  model_attributes,
  node_id = automation?.preview_node
) {
  const dataValues = {};
  if (!job || !automation?.data) return dataValues;
  const data = {};
  const company_files = {};
  for (const key in companyFiles) {
    company_files[companyFiles[key].name.replace(/\./g, ' ')] = {
      file_path: `company_files/${user_group}/`,
      files: [{ name: companyFiles[key].name, key, type: companyFiles[key].type }]
    };
  }
  const startingDataset = {
    user: { email: self.katapultAuth?.user?.email },
    data,
    job,
    node_id,
    user_group,
    company_files,
    model_attributes
  };
  const dataset = await GetKLogicDatasetBuilder((automation.type == 'Node' ? 'NODE' : 'JOB') + '_WEB_AUTOMATIONS', {}).buildDataset(
    startingDataset
  );
  if (dataset.job?.metadata?.attachment_owner) {
    try {
      dataset.attacher_info = await FirebaseWorker.ref(
        `/utility_info/${globalThis.config?.firebaseData?.utilityCompany}/attachers/${dataset.job.metadata.attachment_owner}`
      )
        .once('value')
        .then((s) => s.val());
    } catch (e) {
      console.log('Cannot fetch attacher info', e);
    }
  }
  if (automation.type == 'Node') {
    const spansData = await getSpansNodeList(job, user_group, { attachmentsPerPage: 6 });
    dataset.spans_attributes = spansData.find((spans) => spans.node_id == node_id);
  }

  Object.entries(automation.data)
    .filter(([key, value]) => value)
    .sort(([keyA, valueA], [keyB, valueB]) => valueA.order - valueB.order)
    .forEach(([key, item]) => {
      let value = null;
      if (item.logic) {
        try {
          value = KLogic.compute(item.logic, dataset);
        } catch (e) {
          console.error(e);
          value = '(Logic Error)';
        }
      }
      const dataValue = { value, error_messages: [], status: 'ok' };
      data[item.name] = value;
      Object.values(item.error_messages ?? {})
        .sort((a, b) => a.order - b.order)
        .forEach((message) => {
          let text = '';
          try {
            if (message.logic && KLogic.compute(message.logic, dataset)) {
              text = message.text;
            }
          } catch (e) {
            console.error(e);
            text = '(Logic Error)';
          }
          if (text) {
            dataValue.error_messages.push({ text, type: message.type });
            if (message.type == 'Error') dataValue.status = 'Error';
            else if (message.type == 'Warning' && dataValue.status != 'Error') dataValue.status = 'Warning';
          }
        });
      dataValues[key] = dataValue;
    });
  return { dataValues, dataset };
}
